import { useConfigStore, useContactLensesStore } from "@/store";
import { PrescriptionData } from "@/types/prescription.types";
import { useState, useEffect } from "react";

export const useMyAccountPrescription = () => {
  const [prescriptions, setPrescriptions] = useState<PrescriptionData[] | null>(
    null,
  );

  const { config } = useConfigStore();
  const { contactLensesData } = useContactLensesStore();

  const retrieveFromMyAccount =
    config?.prescriptionModule.retrieveFromMyAccount;

  const productID =
    contactLensesData.OD?.product?.catalogEntryIdentifier?.uniqueId ||
    contactLensesData.OS?.product?.catalogEntryIdentifier?.uniqueId;

  useEffect(() => {
    if (!retrieveFromMyAccount) {
      console.warn(
        "PrescriptionModule or retrieveFromMyAccount function is not defined in config. My Account prescription retrieval will not work.",
      );
    }

    const fetchPrescriptions = async () => {
      if (retrieveFromMyAccount) {
        try {
          const data = await retrieveFromMyAccount(productID || "");
          // filtered prescriptions based on product ID and eye
          const filteredData = data?.filter((prescription) => {
            const ODId =
              contactLensesData?.OD?.product?.catalogEntryIdentifier?.uniqueId;
            const OSId =
              contactLensesData?.OS?.product?.catalogEntryIdentifier?.uniqueId;
            if (ODId && OSId) {
              return (
                ODId.toString() ===
                  prescription.rightCatentryParentId.toString() &&
                OSId.toString() === prescription.leftCatentryParentId.toString()
              );
            } else if (ODId && !OSId) {
              return (
                ODId.toString() ===
                prescription.rightCatentryParentId.toString()
              );
            } else if (!ODId && OSId) {
              return (
                OSId.toString() === prescription.leftCatentryParentId.toString()
              );
            }
          });
          setPrescriptions(filteredData);
        } catch (error) {
          throw new Error(
            "Error retrieving prescriptions from My Account: " + error,
          );
        }
      }
    };

    fetchPrescriptions();
  }, [retrieveFromMyAccount]);

  return { prescriptions };
};
